<template>
  <div class="sp_view">
    <el-form ref="labelForm" :model="{labelForm}" class="demo-dynamic">
      <el-form-item
        prop="name"
      >
        <div style="display: flex; justify-content: left;">
          <div style="width: 100px;"> 标签组名称</div>
          <el-input v-model="labelForm.group_name" :disabled="true" />
        </div>

      </el-form-item>
      <el-form-item
        v-for="(item,index) in labelForm.children"
        :key="index"
        :prop="item.tag_name"
      >
        <div style="display: flex; justify-content: space-between;align-items: center;">
          <div style="width: 100px;margin-right: 10px;">标签</div>
          <el-input v-model="item.tag_name" />
          <i style="font-size: 20px;line-height: 36px;margin-left: 10px;" class="el-icon-delete" @click.prevent="removeDomain(item)" />
          <!-- <el-button style="margin-left: 10px;" @click.prevent="removeDomain(item)">删除</el-button> -->
          <!-- <div v-if="index===0" style="width: 25px;height: 36px;margin-left: 10px;" /> -->
        </div>

      </el-form-item>
      <el-form-item>

        <el-button icon="el-icon-plus" type="text" @click="addDomain">添加标签</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="sumbit()">确认</el-button>
      </el-form-item>
    </el-form>
  </div>

</template>

<script>

import { editCorpTag, delCorpTag } from '@/api/numberTemplatemessage'
export default {
  components: {
  },
  data() {
    return {
      labelForm: [],
      corp_id: '',
      tag: '',
      group_id: ''
    }
  },
  created() {

  },
  mounted() {
  },
  activated() {

  },
  methods: {
    send(item) {
      console.log(item)
      this.labelForm = item
      this.corp_id = this.$route.query.id
    },
    async sumbit() {
      this.labelForm.children.forEach((item, index) => {
        if (item.tag_name === '') {
          this.$message.error('请输入标签名称')
        }
        return
      })

      const data = await editCorpTag({
        corp_id: this.corp_id,
        group_id: this.labelForm.group_id,
        tag: this.labelForm.children
      })
      console.log('data', data)
      this.$emit('editlabel')
    },
    removeDomain(item) {
      console.log('remove-----', item)
      this.tag = item.tag_id
      if (this.tag === '') {
        console.log('kong')
        var index = this.labelForm.children.indexOf(item)
        if (index !== -1) {
          this.labelForm.children.splice(index, 1)
        }
      } else {
        this.$confirm(this.$t('确认要删除标签？删除标签后，该标签下所有客户将取消此标签'), this.$t('提示'), {
          confirmButtonText: this.$t('确定'),
          cancelButtonText: this.$t('取消'),
          type: 'warning'
        }).then(async() => {
          const data = await delCorpTag({
            corp_id: this.corp_id,
            group_id: this.labelForm.group_id,
            tag_id: this.tag
          })
          if (data.code === 200) {
            this.$message.success('标签删除成功')
            var index = this.labelForm.children.indexOf(item)
            if (index !== -1) {
              this.labelForm.children.splice(index, 1)
            }
          } else {
            this.$message.error('标签删除失败')
          }
        }).catch(() => {

        })
      }

      console.log('removeDomain', item)
    },
    addDomain() {
      this.labelForm.children.push({
        tag_id: '',
        tag_name: ''
      })
      // if (this.labelForm.list.length < 5) {
      //   this.labelForm.list.push({
      //     tag_name: ''
      //   })
      // } else {
      //   this.$message.warning('标签不能超过5条')
      //   return
      // }
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.sp_view{
  padding:10px 20px;
}
.addbox{
  margin-bottom: 15px;
}
.title{
  line-height: 30px;
}
</style>
